import { LoadScript } from "@react-google-maps/api";
import React, { useContext, useEffect, useState } from "react";
import { GoogleMap, Marker } from '@react-google-maps/api';
import { getMapName } from "../../services/maps-api";
import { getSchoolTypeFromId } from "../../utility/api-utilities";
import { mapStyles } from "../results/map-container-config";
import { AppContext } from "../school-search-app";
import { PAGE_MODE } from '../../interfaces'

function BannerMap({ school, height }) {
    const CHICAGO = { lat: 41.87832960158098, lng: -88.0 }
    const [map, setMap] = useState(null);
    const [center, setCenter] = useState(CHICAGO);
    const [marker, setMarker] = useState(null);

    const appContext = useContext(AppContext)

    const cel = school.SchoolCPSCode ? true : false;

    useEffect(() => {
        const cel = school.SchoolCPSCode ? true : false;
        const map = cel ? 'DFSS' : 'School'

        let checkId;
        if (appContext.mode == PAGE_MODE.SUMMER_PROGRAMM) {
            checkId = school.id;
        }
        else {
            checkId = cel ? school.SchoolCPSCode : school.schoolID;
        }

        getMapName(map, 2022, appContext.mode).then(res => {
            const feature = res.features.filter(s => s.properties.School_ID == checkId)[0];
            if (school) {
                feature.properties.short_school_name = school.SchoolShortName;
            }
            setMarker(feature)
            setCenter({
                lat: feature.geometry.coordinates[1],
                lng: feature.geometry.coordinates[0]
            })
        })
    }, [school])

    const onLoad = (map) => {
        setMap(map);
    }

    const containerStyle = {
        width: '100%',
        height: height
    };

    let markerUrl = '/Static-Adage/img/search/GoCPS_';
    if (appContext.mode == PAGE_MODE.SUMMER_PROGRAMM) {
        markerUrl = '/Static-Adage/img/search/Program_Map_Marker.svg';
    }
    else {
        if (cel) {
            markerUrl += 'CEL_';
        }
        else {
            markerUrl += 'CPS_';
            if (appContext.mode == PAGE_MODE.GOCPS) {
                if (school.isHighSchool) {
                    markerUrl += 'HS_';
                }
                else {
                    markerUrl += 'ES_';
                }
            }
        }
        markerUrl += 'Map_Marker.svg';
    }

    return <GoogleMap
        mapContainerStyle={containerStyle}
        options={{
            disableDefaultUI: true,
            gestureHandling: "none",
            zoomControl: false,
            styles: mapStyles
        }}

        center={center}
        zoom={14}
        onLoad={onLoad}
    >

        {marker && (typeof google !== 'undefined') && (<Marker

            position={{
                lat: marker.geometry.coordinates[1],
                lng: marker.geometry.coordinates[0]
            }}
            icon={{
                url: markerUrl,
                scaledSize: new google.maps.Size(60, 75), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(30, 75) // anchor
            }}
            label={{
                text: marker.properties.short_school_name || marker.properties.Short_Name,
                className: 'school_marker_name',
                fontSize: '12px',
                fontWeight: 'bold',
            }}
        />)}

    </GoogleMap>
}

export default BannerMap